(() => {
  class BenefitsSlider {
    constructor(root) {
      this.root = root;
      this.track = root.querySelector('[data-benefit-track]');
      this.autoplay = root.dataset.autoplay === 'true';
      this.delay = Number(root.dataset.delay) || 5000;
      this.timer = null;
      this.bind();
      if (this.autoplay) this.play();
    }

    bind() {
      this.root.querySelector('[data-benefit-prev]')?.addEventListener('click', () => {
        this.scrollBy(-1);
        this.play();
      });
      this.root.querySelector('[data-benefit-next]')?.addEventListener('click', () => {
        this.scrollBy(1);
        this.play();
      });
      this.root.addEventListener('mouseenter', () => this.stop());
      this.root.addEventListener('mouseleave', () => this.play());
    }

    stepSize() {
      const slide = this.track?.querySelector('[data-benefit-slide]');
      if (!slide) return 280;
      const styles = window.getComputedStyle(this.track);
      const gap = parseFloat(styles.columnGap || styles.gap) || 16;
      return slide.getBoundingClientRect().width + gap;
    }

    scrollBy(direction) {
      if (!this.track) return;
      const max = this.track.scrollWidth - this.track.clientWidth;
      if (direction > 0 && this.track.scrollLeft >= max - 8) {
        this.track.scrollTo({ left: 0, behavior: 'smooth' });
        return;
      }
      if (direction < 0 && this.track.scrollLeft <= 8) {
        this.track.scrollTo({ left: max, behavior: 'smooth' });
        return;
      }
      this.track.scrollBy({ left: this.stepSize() * direction, behavior: 'smooth' });
    }

    play() {
      this.stop();
      if (!this.autoplay || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
      this.timer = window.setInterval(() => this.scrollBy(1), this.delay);
    }

    stop() {
      if (this.timer) window.clearInterval(this.timer);
      this.timer = null;
    }
  }

  const init = () => {
    document.querySelectorAll('[data-benefits]').forEach((root) => {
      if (root.dataset.bnReady) return;
      root.dataset.bnReady = 'true';
      new BenefitsSlider(root);
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init);
})();
